import moment from 'moment';
import { CalendarIcon, CompanyIcon, DistanceIcon, FlagIcon, PeopleIcon, PersonIcon, RideIcon, SavedCO2Icon } from '../components/icons';

/** `rank_field` query param of `GET /v5/challenges/:id/leaderboard` — the metric a `custom`
 * challenge's leaderboard is ranked by. Defaults to `progress_value` (points). */

export const challengeTypes = [{
  key: 'traveledDistance',
  Icon: DistanceIcon,
  labelKey: 'commons.challenges.types.distance',
  descriptionKey: 'commons.challenges.types.distance_description'
}, {
  key: 'cyclingDays',
  Icon: CalendarIcon,
  labelKey: 'commons.challenges.types.cycling_days',
  descriptionKey: 'commons.challenges.types.cycling_days_description'
}, {
  key: 'journeysCount',
  Icon: RideIcon,
  labelKey: 'commons.challenges.types.journeys',
  descriptionKey: 'commons.challenges.types.journeys_description'
}, {
  key: 'bttf',
  Icon: SavedCO2Icon,
  labelKey: 'commons.challenges.types.bttf',
  descriptionKey: 'commons.challenges.types.bttf_description'
}];
export const collaborationTypes = [{
  key: 'individual',
  Icon: PersonIcon,
  labelKey: 'commons.challenges.competition_types.individual',
  descriptionKey: 'commons.challenges.competition_types.individual_description'
}, {
  key: 'teams',
  Icon: FlagIcon,
  labelKey: 'commons.challenges.competition_types.teams',
  descriptionKey: 'commons.challenges.competition_types.teams_description'
}, {
  key: 'sites',
  Icon: CompanyIcon,
  labelKey: 'commons.challenges.competition_types.sites',
  descriptionKey: 'commons.challenges.competition_types.sites_description'
}, {
  key: 'global',
  Icon: PeopleIcon,
  labelKey: 'commons.challenges.competition_types.global',
  descriptionKey: 'commons.challenges.competition_types.global_description'
}];
export class Challenge {
  constructor(id, type, collaborationType, traceType, startDate, endDate, title, description, photo, detailsUrl, nbMembers, progressValue, targetValue, publicationStatus, eventId, subGroupDisplay, group, isLocal, sponsor, certified, eventAutomaticSubscription, metricsWeights, commonProgressWeightingDetails, summaryVideo, coveredByPaidContract) {
    this.id = id;
    this.type = type;
    this.collaborationType = collaborationType;
    this.traceType = traceType;
    this.startDate = startDate;
    this.endDate = endDate;
    this.title = title;
    this.description = description;
    this.photo = photo;
    this.detailsUrl = detailsUrl;
    this.nbMembers = nbMembers;
    this.progressValue = progressValue;
    this.targetValue = targetValue;
    this.publicationStatus = publicationStatus;
    this.eventId = eventId;
    this.subGroupDisplay = subGroupDisplay;
    this.group = group;
    this.isLocal = isLocal;
    this.sponsor = sponsor;
    this.certified = certified;
    this.eventAutomaticSubscription = eventAutomaticSubscription;
    this.metricsWeights = metricsWeights;
    this.commonProgressWeightingDetails = commonProgressWeightingDetails;
    this.summaryVideo = summaryVideo;
    this.coveredByPaidContract = coveredByPaidContract;
    const now = moment();
    if (endDate.isBefore(now)) this.period = 'past';else if (startDate.isAfter(now)) this.period = 'future';else this.period = 'current';
    this.progressPercentage = targetValue > 0 ? Math.min(Math.floor(progressValue / targetValue * 100), 100) : 0;
    this.overralProgressValue = collaborationType === 'global' ? progressValue : 0;
    this.overralProgressPercentage = targetValue > 0 ? Math.min(Math.floor(this.overralProgressValue / targetValue * 100), 100) : 100;
  }
  get daysLeft() {
    const diff = this.endDate.diff(moment(), 'days', true);
    return moment().isAfter(this.endDate) ? Math.ceil(diff - 1) : Math.ceil(diff);
  }
  get daysToWait() {
    return this.startDate.diff(moment().startOf('day'), 'days');
  }
}
export class ChallengeTemplate {
  constructor(id, type, collaborationType, traceType, startDate, endDate, title, description, photo, detailsUrl, targetValue, eventId, subGroupDisplay, group, isLocal, sponsor, metricsWeights, progressWeightingMode) {
    this.id = id;
    this.type = type;
    this.collaborationType = collaborationType;
    this.traceType = traceType;
    this.startDate = startDate;
    this.endDate = endDate;
    this.title = title;
    this.description = description;
    this.photo = photo;
    this.detailsUrl = detailsUrl;
    this.targetValue = targetValue;
    this.eventId = eventId;
    this.subGroupDisplay = subGroupDisplay;
    this.group = group;
    this.isLocal = isLocal;
    this.sponsor = sponsor;
    this.metricsWeights = metricsWeights;
    this.progressWeightingMode = progressWeightingMode;
    const now = moment();
    if (endDate.isBefore(now)) this.period = 'past';else if (startDate.isAfter(now)) this.period = 'future';else this.period = 'current';
  }
  get daysLeft() {
    return this.endDate.diff(moment().startOf('day'), 'days') + 1;
  }
  get daysToWait() {
    return this.startDate.diff(moment().startOf('day'), 'days');
  }
}